
export const host = 'https://oxx-api.vercel.app/'
export const dev_host = 'http://127.0.0.1:8000/'

/* URL para obter todos os Imoveis Cadastrados */
export const imvs_url = 'https://oxx-api.vercel.app/faiimoveis_/imoveis/'

/* Url para obter os imoveis ativos */
export const active_url = 'https://oxx-three.vercel.app/faiimoveis_/actives/'

// URL Para Cadastrar Imoveis
export const imv_reg_url = 'https://oxx-api.vercel.app/'
export const dev_reg_url = 'http://127.0.0.1:8000/faiimoveis/admin/registro_imv/'

export const edit_imv_url = 'https://oxx-api.vercel.app/faiimoveis_/imoveis/${id}'

export const admin_login_path = 'faiimoveis/admin/login/'